/**
 * Share Modal Template (shared between dashboard and viewer)
 * Injected synchronously to ensure it's available before other scripts run
 */
(function() {
  const modalHTML = `
<!-- Share Modal -->
<div id="shareModal" class="modal">
  <div class="modal-content share-modal-content">
    <div class="modal-header">
      <h3 id="shareModalTitle">Share "Simulation"</h3>
      <button class="close-modal">&times;</button>
    </div>
    <div class="modal-body">
      <!-- Invite Section -->
      <div class="share-section">
        <label class="share-section-label">Invite by Email</label>
        <div class="share-invite-row">
          <input type="email" id="shareEmail" class="share-email-input" placeholder="colleague@example.com">
          <select id="shareRole" class="share-role-select">
            <option value="viewer">Viewer (view only)</option>
            <option value="editor">Editor (can download)</option>
          </select>
          <button id="btnSendInvite" class="btn-primary share-send-btn">Send Invite</button>
        </div>
      </div>

      <!-- Collaborators List -->
      <div class="share-section share-collaborators">
        <label class="share-section-label">Who has access</label>
        <div id="collaboratorsList" class="collaborators-list">
          <div class="empty-collaborators">No collaborators yet</div>
        </div>
      </div>

      <!-- Public Link Section -->
      <div class="share-section share-public-link">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
          <label class="share-section-label" style="margin-bottom: 0;">Public Link</label>
          <div id="publicLinkStatus" style="display: flex; align-items: center; gap: 10px;">
            <span id="publicLinkStatusText" style="font-size: 0.85rem; color: #94a3b8;">Not enabled</span>
            <label class="public-link-toggle">
              <input type="checkbox" id="publicLinkToggle">
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
        <p id="publicLinkInfo" style="font-size: 0.8rem; color: #6b7280; margin: 0 0 12px 0;">Enable to allow anyone with the link to view this simulation.</p>
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
          <label style="font-size: 0.85rem; color: #94a3b8; white-space: nowrap;">Link expires:</label>
          <select id="shareLinkExpiry" class="share-role-select" style="flex: 1;">
            <option value="never">Never</option>
            <option value="1">1 hour</option>
            <option value="6">6 hours</option>
            <option value="24" selected>24 hours</option>
            <option value="168">7 days</option>
            <option value="720">30 days</option>
          </select>
          <span id="shareLinkExpiryInfo" style="font-size: 0.75rem; color: #6b7280; display: none;"></span>
        </div>
        <div id="publicLinkContainer" style="display: flex; flex-direction: row; align-items: stretch; gap: 8px;">
          <input type="text" id="publicLinkInput" class="public-link-input" readonly
            style="flex: 1; height: 40px; padding: 0 14px; box-sizing: border-box; margin: 0;">
          <button id="btnCopyLink" class="btn-copy"
            style="display: flex; align-items: center; justify-content: center; height: 40px; padding: 0 16px; box-sizing: border-box; margin: 0; gap: 6px;">
            <img src="static/assets/icons/copy.svg" alt="" width="16" height="16" style="opacity: 0.9;">
            <span>Copy</span>
          </button>
          <button id="btnRegenerateLink" class="btn-secondary"
            style="display: flex; align-items: center; justify-content: center; height: 40px; padding: 0 16px; box-sizing: border-box; margin: 0; gap: 6px; background: #ef4444; border-color: #dc2626;"
            title="Regenerate link (old link will stop working)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="opacity: 0.9;">
              <polyline points="23 4 23 10 17 10"></polyline>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
            <span>New Link</span>
          </button>
        </div>
        <p style="font-size: 0.75rem; color: #9ca3af; margin-top: 8px;">
          <strong>Note:</strong> Regenerating the link will invalidate the old link. Anyone with the old link will lose access.
        </p>
      </div>
    </div>
  </div>
</div>`;

  // Inject modal HTML immediately when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectModal);
  } else {
    // DOM already loaded, inject immediately
    injectModal();
  }

  function injectModal() {
    // Check if modal already exists (avoid duplicate injection)
    if (document.getElementById('shareModal')) {
      return;
    }
    const temp = document.createElement('div');
    temp.innerHTML = modalHTML;
    document.body.appendChild(temp.firstElementChild);
    console.log('[ShareModal] Injected shared modal HTML');
  }
})();
